import React from 'react';
import { Badge, Spinner } from 'react-bootstrap';
import { DataResponse } from 'gossamer-unified';
import { isNotFound } from './ReduxGCacheMiddleware';

interface ParallelLoadProps {
  children: React.JSX.Element;
  responses: DataResponse[];
  ignoreErrors?: boolean;
}

export const ParallelLoad = (props: ParallelLoadProps): React.JSX.Element => {
  const isLoading = props.responses.reduce((prev, response) => prev || (!response.data && !response.error), false);
  if (isLoading) {
    return <Spinner animation="border" size="sm" role="status" aria-hidden="true" />;
  }
  if (!props.ignoreErrors) {
    const error_responses = props.responses.filter((response) => !!response.error);
    if (error_responses.length > 0) {
      error_responses.forEach(console.error);
      if (error_responses.every((response) => isNotFound(response))) {
        return <Badge bg="warning">Not found</Badge>;
      }
      return <Badge bg="danger">Error(s) occurred loading data</Badge>;
    }
  }
  return props.children;
};
